import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/price_packages',
    name: 'price_packages',
    component: () => import('@/views/pages/price-packages/PricePackagesList.vue'),
    meta: {
      pageTitle: 'Price Packages',
      breadcrumb: {
        label: 'Price Packages'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN],
      verticalMenu: {
        title: 'Price Packages',
        icon: 'PocketIcon',
        parent: 'priceManagement'
      }
    }
  },
  {
    path: '/price_packages/create',
    name: 'create_price_package',
    component: () => import('@/views/pages/price-packages/CreatePricePackage.vue'),
    meta: {
      pageTitle: 'Create Price Packages',
      breadcrumb: {
        label: 'Create Price Packages',
        parent: 'price_packages'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/price_packages/:id',
    name: 'edit_price_package',
    component: () => import('@/views/pages/price-packages/EditPricePackage.vue'),
    meta: {
      pageTitle: 'Edit Price Packages',
      breadcrumb: {
        label: 'Edit Price Packages',
        parent: 'price_packages'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },

  {
    path: '/price_packages/:packageId/provider/:providerId/region-rates',
    name: 'providers_region_rates',
    component: () => import('@/views/pages/price-packages/PackageProviderList.vue'),
    meta: {
      pageTitle: 'Provider Region Rates',
      breadcrumb: {
        label: 'Provider Region Rates',
        parent: 'price_packages'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  }
];
